import React, { FC } from 'react'
import { Box } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

export const Separator: FC = () => <Box borderBottom={`1px solid ${brandColors.coolGray1}`} />
